var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 28.3332V6.6665H3.33331V28.3332H16.6666V31.6665H13.3333V33.3332H26.6666V31.6665H23.3333V28.3332H36.6666ZM4.99998 8.33317H35V26.6665H4.99998V8.33317ZM21.6666 31.6665H18.3333V28.3332H21.6666V31.6665ZM14.1666 22.4998H6.66665V14.9998H14.1666V22.4998ZM8.33331 20.8332H12.5V16.6665H8.33331V20.8332ZM24.1666 22.4998H15.8333V14.9998H24.1666V22.4998ZM17.5 20.8332H22.5V16.6665H17.5V20.8332ZM33.3333 22.4998H25.8333V14.9998H33.3333V22.4998ZM27.5 20.8332H31.6666V16.6665H27.5V20.8332ZM20 11.6665H6.66665V9.99984H20V11.6665ZM33.3333 11.6665H31.6666V9.99984H33.3333V11.6665ZM30 11.6665H28.3333V9.99984H30V11.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.17b53d19cc0abe5317bc748ebd859a93.svg";
export { ForwardRef as ReactComponent };